import { attachPhoneFormat, PHONE_UTILS } from "../basics/phoneField";

export default function useCartCustomer() {
    function initPhoneInput(ctx, selector = "#phone-cart") {
        setTimeout(() => {
            const phoneInput = document.querySelector(selector);
            if (ctx.iti == null && phoneInput !== undefined && phoneInput !== null) {
                ctx.iti = intlTelInput(phoneInput, {
                    separateDialCode: true,
                    initialCountry: user_country.toLowerCase() ?? "hu",
                    utilsScript: PHONE_UTILS,
                });
                attachPhoneFormat(ctx.iti, phoneInput);
            }
        }, 100);
    }

    function logout(ctx) {
        // "not you?": the login is dropped for good (a reload must not log
        // back in) and nothing of the previous user stays on the page
        Cookies.setItem("login_token", "", -1);
        ctx.loggedDataIncomplete = false;
        ctx.isLogged = false;
        ctx.canLogin = false;
        ctx.startLogin = false;
        ctx.showLoginFields = true;
        ctx.email = "";
        ctx.phone = "";
        ctx.loginCode = "";
        ctx.uadressess = [];
        ctx.userBill = null;
        ctx.invoice = null;
        ctx.invoiceTouched = false;
        ctx.ownBillAddress = null;
        ctx.clearSelectedShipping();
        ctx.clearBillingAddress();
        ctx.newAddress = true;
        if (ctx.order?.id > 0) {
            ctx.abandonDraftOrder(); // the draft belongs to the previous user
        }
        ctx.userData = {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            taxCode: "",
            countryID: "",
            euTaxCode: "",
        };
        setTimeout(() => {
            forms.load();
            initPhoneInput(ctx, "#phone-cart");
        }, 100);
    }

    function checklogin(ctx) {
        if (Cookies.getItem("login_token") === null) {
            ctx.newAddress = true;
            ctx.isLogged = false;
            return;
        }
        const token = Cookies.getItem("login_token");
        const bodyContent = { token: token || "" };
        // the cart of the page: the customer's own discount on it (the loyalty program's) comes with the answer, no call of its own
        const cartItems = (ctx.items ?? []).filter((product) => product.id !== null && product.id !== undefined)
            .map((product) => ({id: product.id, quantity: product.quantity}));
        if (cartItems.length > 0 && ctx.countryShipping?.id) {
            bodyContent.items = cartItems;
            bodyContent.country_id = ctx.countryShipping.id;
        }

        fetch("/api/login/check", {
            method: "POST",
            headers: http.headers(),
            body: JSON.stringify(bodyContent),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.code === 200) {
                    ctx.pinError = "";
                    ctx.isLogged = true;
                    ctx.canLogin = false;
                    ctx.startLogin = false;
                    ctx.userDataError = false;

                    const userData = data.data;
                    ctx.setMemberPrices?.(data?.automatic_discount);
                    ctx.limitedPayments = data?.limited_payments;
                    ctx.userData.taxCode = userData.tax_code;
                    ctx.userData.euTaxCode = userData.eu_tax_code;
                    ctx.userData.countryID = userData.country_id;
                    ctx.userData.firstName = userData.first_name;
                    ctx.userData.lastName = userData.last_name;
                    if (userData.crmItemContacts.length !== 0) {
                        ctx.userData.phoneNumber = userData.crmItemContacts[0].phone;
                        ctx.userData.email = userData.crmItemContacts[0].email;
                    } else {
                        ctx.userData.email = ctx.email;
                    }

                    const validatePhone = function (phone) {
                        return phone.match(/^[\d+]{4,26}/);
                    };

                    // incomplete CRM data (e.g. a phone without +country code):
                    // the user stays logged in, the form asks for the missing data
                    ctx.loggedDataIncomplete = (
                        (ctx.userData.lastName ?? "").length < 2 ||
                        (ctx.userData.firstName ?? "").length < 2 ||
                        (ctx.userData.phoneNumber ?? "").length < 2 ||
                        (ctx.userData.phoneNumber ?? "")[0] !== "+" ||
                        !validatePhone(ctx.userData.phoneNumber ?? "")
                    );
                    if (ctx.loggedDataIncomplete) {
                        ctx.showLoginFields = true;
                        if ((ctx.userData.phoneNumber ?? "")[0] !== "+") {
                            ctx.userData.phoneNumber = "";
                        }
                    }

                    ctx.userBill = {
                        country: userData.country_id,
                        area: userData.invoice_area,
                        state: userData.invoice_state,
                        city: userData.invoice_city,
                        house: userData.invoice_house,
                        street: userData.invoice_street,
                        postcode: userData.invoice_post_code,
                        isCompany: userData.is_business,
                        businessName: userData.is_business ? (userData.name ?? "") : "",
                        taxNumber: userData.tax_code,
                        euTaxNumber: userData.eu_tax_code,
                    };

                    // (re)loaded after a PIN login too: never duplicated
                    ctx.uadressess = [];
                    const seen = new Set();
                    (userData.crmItemAddresses ?? []).forEach((e) => {
                        const key = [e.country_id, e.post_code, e.city, e.street, e.house].join("|");
                        if (seen.has(key)) return;
                        seen.add(key);
                        ctx.uadressess.push({
                            country: e.country_id,
                            city: e.city,
                            postcode: e.post_code,
                            street: e.street,
                            house: e.house,
                            state: e.state,
                            area: e.area,
                        });
                    });
                    ctx.newAddress = ctx.uadressess.length < 1;
                }
            })
            .catch((error) => {
                ctx.newAddress = true;
                console.log("error", error);
            });
    }

    function checkEmail(ctx) {
        const bodyContent = { email: ctx.email };
        if (ctx.needChallenge) {
            bodyContent.h_captcha_response = hcaptcha.getResponse(ctx.captchaID1);
        }
        ctx.emailMistake = false;
        fetch("/api/login/check-email", {
            method: "POST",
            headers: http.headers(),
            body: JSON.stringify(bodyContent),
        })
            .then((response) => {
                if (!response.ok) {
                    ctx.canLogin = false;
                    ctx.startLogin = false;
                    ctx.showLoginFields = true;
                    ctx.userData.email = ctx.email;
                }
                return response.json();
            })
            .then((data) => {
                ctx.userData.email = ctx.email;
                if (data?.limited_payments !== undefined && data?.limited_payments !== null) {
                    ctx.limitedPayments = data.limited_payments;
                }
                if (data?.valid !== undefined && data?.valid !== null) {
                    ctx.emailMistake = !data.valid;
                }
                if (data.user) {
                    ctx.canLogin = true;
                    ctx.showLoginFields = false;
                } else if (data["need-challenge"]) {
                    ctx.showLoginFields = false;
                    const _this = ctx;
                    window.loadCaptcha(() => {
                        if (ctx.needChallenge) {
                            hcaptcha.reset(ctx.captchaID1);
                        } else {
                            _this.needChallenge = data["need-challenge"];
                            _this.captchaID1 = hcaptcha.render(_this.$refs.captcha1, {
                                sitekey: process.env.MIX_HCAPTCHA_TOKEN,
                                callback: () => checkEmail(_this),
                            });
                        }
                    });
                } else {
                    initPhoneInput(ctx, "#phone-cart");
                    ctx.canLogin = false;
                    ctx.showLoginFields = true;
                }
            })
            .catch((error) => {
                ctx.userData.email = ctx.email;
                console.log("error", error);
            })
            .finally(() => {
                ctx.isInputLoding = false;
                ctx.timeout = null;
            });
    }

    function guest(ctx) {
        ctx.canLogin = false;
        ctx.startLogin = false;
        ctx.showLoginFields = true;
        ctx.userData.email = ctx.email;

        setTimeout(() => {
            const phoneInput = document.querySelector("#phone");
            if (ctx.iti == null && phoneInput !== undefined && phoneInput !== null) {
                ctx.iti = intlTelInput(phoneInput, {
                    separateDialCode: true,
                    initialCountry: user_country.toLowerCase(),
                    utilsScript: PHONE_UTILS,
                });
                attachPhoneFormat(ctx.iti, phoneInput);
            }
        }, 400);
    }

    function login(ctx) {
        ctx.canLogin = false;
        ctx.startLogin = true;

        const bodyContent = { email: ctx.email };
        fetch("/api/login/start", {
            method: "POST",
            headers: http.headers(),
            body: JSON.stringify(bodyContent),
        })
            .then((response) => {
                if (!response.ok) {
                    ctx.canLogin = false;
                    ctx.startLogin = false;
                    ctx.showLoginFields = true;
                }
                return response.json();
            })
            .then((data) => {
                ctx.userData.email = ctx.email;
                if (data.code === 200) {
                    ctx.pinToken = data.data["customer-pin-token"];
                }
            })
            .catch((error) => {
                console.log("error", error);
            })
            .finally(() => {
                ctx.isInputLoding = false;
                ctx.timeout = null;
            });
    }

    function getUserData(ctx) {
        const bodyContent = {
            pin: ctx.loginCode + "" || "",
            token: ctx.pinToken || "",
        };

        fetch("/api/login/validate", {
            method: "POST",
            headers: http.headers(),
            body: JSON.stringify(bodyContent),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.code === 200) {
                    const token = data.data["customer-api-token"];
                    Cookies.setItem("login_token", token);
                    checklogin(ctx);
                } else if (data.errors && data.errors.pin) {
                    ctx.pinError = data.errors.pin[0];
                }
            })
            .catch((error) => {
                console.log("error", error);
            })
            .finally(() => {
                ctx.isInputLoding = false;
            });
    }

    return { initPhoneInput, logout, checklogin, checkEmail, guest, login, getUserData };
}